module.exports = __webpack_public_path__ + "img/sub_main_인재채용.2bbd64fd.png";